module.exports = __webpack_public_path__ + "static/media/icon_2.38b5b322.png";